// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import pinitEntity from './entities/pinit.json';
import pinitMenu from '../pages/pinit/menu.json';
import pinitFullForm from '../pages/pinit/forms/full.json';
import pinitContextForm from '../pages/pinit/forms/context.json';
import pinitMiniForm from '../pages/pinit/forms/mini.json';
import pinitLookupForm from '../pages/pinit/forms/lookup.json';
import pinitTableView from '../pages/pinit/views/table.json';
import pinitStagesView from '../pages/pinit/views/stages.json';
import pinitCardsView from '../pages/pinit/views/cards.json';
import pinitInlineView from '../pages/pinit/views/inline.json';
import pinitBacklogView from '../pages/pinit/views/backlog.json';
import pinitSplitView from '../pages/pinit/views/split.json';
import pinitCalendarView from '../pages/pinit/views/calendar.json';
import pinitDashboardView from '../pages/pinit/views/dashboard.json';

/** Тип запису «Ініціатива» зі сторінками пакета: меню, форми та подання з pages/pinit/. */
export const pinitDefinition: IRecordTypeDefinition = {
  ...pinitEntity,
  views: assembleViewSet({
      table: pinitTableView,
      stages: pinitStagesView,
      cards: pinitCardsView,
      inline: pinitInlineView,
      backlog: pinitBacklogView,
      split: pinitSplitView,
      calendar: pinitCalendarView,
      dashboard: pinitDashboardView,
  }),
  form: pinitFullForm,
  forms: { full: pinitFullForm, context: pinitContextForm, mini: pinitMiniForm, lookup: pinitLookupForm },
  menu: pinitMenu,
} as IRecordTypeDefinition;
